(function () {
  var SECTION_SELECTOR = '.oddit-section-testimonials';
  var CARD_SELECTOR = '.oddit-section-testimonials__card';
  var TAG_SELECTOR = '.oddit-section-testimonials__tag';
  var DESKTOP = '(min-width: 990px)';
  var SPRING_W = 14;
  var MIN_FLING = 0.08;
  var VEL_WINDOW = 100;
  var THROW_HORIZON = 130;
  var MAX_THROW_CARDS = 3;
  var YOTPO_API = 'https://api-cdn.yotpo.com/v1/widget/';
  var YOTPO_POOL_SIZE = 100;
  var YOTPO_PRODUCT_SIZE = 10;
  var yotpoRequests = {};

  function sanitizeClone(node) {
    node.setAttribute('aria-hidden', 'true');
    var all = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
    all.forEach(function (el) {
      if (el.id) el.removeAttribute('id');
      el.removeAttribute('data-setting-id');
      el.removeAttribute('data-placeholder');
      if (el.classList) {
        Array.prototype.slice.call(el.classList).forEach(function (name) {
          if (name.indexOf('oddit-reveal') === 0) el.classList.remove(name);
        });
      }
      if (el.style) {
        el.style.removeProperty('opacity');
        el.style.removeProperty('transform');
        el.style.removeProperty('--oddit-stagger-index');
      }
      ['clip-path', 'mask', 'fill', 'stroke', 'filter'].forEach(function (attr) {
        var value = el.getAttribute(attr);
        if (value && value.indexOf('url(#') !== -1) el.removeAttribute(attr);
      });
    });
    node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    return node;
  }

  function initSection(section) {
    if (section._odditTeardown) return;

    var track = section.querySelector('.oddit-section-testimonials__track');
    var inner = section.querySelector('.oddit-section-testimonials__track-inner');
    if (!track || !inner) return;

    var allCards = Array.prototype.slice.call(inner.querySelectorAll(CARD_SELECTOR));
    var originals = allCards.slice();
    var N = originals.length;
    var carousel = N >= 2;

    var controller = new AbortController();
    var listen = { signal: controller.signal };
    var desktop = window.matchMedia(DESKTOP);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var looping = false;
    var wrapped = true;
    var clones = [];
    var origin = 0;
    var setW = 0;
    var pitch = 0;
    var x = 0;
    var velocity = 0;
    var raf = null;
    var dragging = false;
    var moved = false;
    var pointerStartX = 0;
    var pointerStartPos = 0;
    var samples = [];
    var resizeTimer = null;

    function stopAnim() {
      if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
      inner.style.removeProperty('will-change');
    }

    function render() {
      var offset = ((x % setW) + setW) % setW;
      inner.style.transform = 'translate3d(' + (origin - offset - setW) + 'px,0,0)';
    }

    function dropClones() {
      clones.forEach(function (node) { node.remove(); });
      clones = [];
      inner.style.removeProperty('transform');
      track.style.removeProperty('justify-content');
      track.style.removeProperty('padding-inline');
      setW = 0;
    }

    // Mobile is Model A: the global runtime settles a mouse drag by scanning
    // `track.children` for the nearest snap-aligned slide, so the cards have to
    // BE the track's children. Desktop is Model B and needs them inside the
    // transform strip instead. Move them, and carry the stagger container along.
    function setWrapped(want) {
      if (wrapped === want) return false;
      wrapped = want;
      if (want) {
        track.appendChild(inner);
        originals.forEach(function (card) { inner.appendChild(card); });
        if (track.hasAttribute('data-oddit-stagger')) {
          track.removeAttribute('data-oddit-stagger');
          inner.setAttribute('data-oddit-stagger', '');
        }
      } else {
        while (inner.firstChild) track.appendChild(inner.firstChild);
        inner.remove();
        if (inner.hasAttribute('data-oddit-stagger')) {
          inner.removeAttribute('data-oddit-stagger');
          track.setAttribute('data-oddit-stagger', '');
        }
      }
      return true;
    }

    // Re-run the global runtime over the section after the DOM shape changes.
    function refresh() {
      section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    }

    // The global [data-oddit-drag-scroll] runtime owns the mobile scroller. On
    // desktop this section owns the drag instead — claim the runtime's own
    // idempotency guard so the two never both bind to one track.
    function claimDrag() {
      if (track._odditDragCtrl && track._odditDragCtrl !== controller) {
        track._odditDragCtrl.abort();
      }
      track._odditDragCtrl = controller;
    }

    function releaseDrag() {
      if (track._odditDragCtrl !== controller) return;
      delete track._odditDragCtrl;
    }

    function build() {
      dropClones();
      if (!N) return;

      origin = inner.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.style.justifyContent = 'flex-start';
      track.style.paddingInline = '0';

      var leading = document.createDocumentFragment();
      originals.forEach(function (card) {
        var clone = sanitizeClone(card.cloneNode(true));
        clones.push(clone);
        leading.appendChild(clone);
      });
      inner.insertBefore(leading, originals[0]);

      var all = inner.querySelectorAll(CARD_SELECTOR);
      setW = all[N].getBoundingClientRect().left - all[0].getBoundingClientRect().left;
      if (!(setW > 0)) { dropClones(); return; }
      pitch = setW / N;

      var sets = Math.max(3, Math.ceil((track.clientWidth - origin) / setW) + 2);
      var trailing = document.createDocumentFragment();
      for (var s = 2; s < sets; s++) {
        originals.forEach(function (card) {
          var clone = sanitizeClone(card.cloneNode(true));
          clones.push(clone);
          trailing.appendChild(clone);
        });
      }
      inner.appendChild(trailing);
      render();
    }

    function enable() {
      var changed = setWrapped(true);
      if (!looping) { looping = true; claimDrag(); }
      stopAnim();
      dragging = false;
      x = 0;
      build();
      if (changed) refresh();
    }

    function disable() {
      if (looping) {
        looping = false;
        stopAnim();
        dragging = false;
        track.classList.remove('is-dragging');
        x = 0;
        dropClones();
      }
      var changed = setWrapped(false);
      releaseDrag();
      if (changed) refresh();
    }

    function apply() {
      if (!carousel) return;
      if (desktop.matches) enable(); else disable();
    }

    // Filtering rebuilds the loop: restore every card in source order, drop the
    // ones that don't match, then let the carousel re-measure.
    function applyFilter(value) {
      stopAnim();
      dropClones();
      var host = wrapped ? inner : track;
      allCards.forEach(function (card) { host.appendChild(card); });
      originals = allCards.filter(function (card) {
        var match = value === 'all' || card.getAttribute('data-oddit-category') === value;
        if (!match) card.remove();
        return match;
      });
      // A card that was clipped out of view may never have been revealed.
      originals.forEach(function (card) {
        card.classList.add('is-visible');
        card.querySelectorAll('.oddit-reveal').forEach(function (el) { el.classList.add('is-visible'); });
      });
      N = originals.length;
      carousel = N >= 2;
      x = 0;
      if (carousel) apply(); else disable();
    }

    Array.prototype.slice.call(section.querySelectorAll(TAG_SELECTOR)).forEach(function (tag, _i, tags) {
      tag.addEventListener('click', function () {
        tags.forEach(function (other) {
          var on = other === tag;
          other.classList.toggle('oddit-section-testimonials__tag--active', on);
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilter(tag.getAttribute('data-oddit-filter') || 'all');
      }, listen);
    });

    function settle(target, startVelocity) {
      if (reduced) { x = target; render(); inner.style.removeProperty('will-change'); return; }
      velocity = startVelocity;
      var last = null;
      raf = requestAnimationFrame(function step(now) {
        if (last === null) last = now;
        var dt = Math.min((now - last) / 1000, 0.05);
        last = now;
        var d0 = x - target;
        var b = velocity + SPRING_W * d0;
        var decay = Math.exp(-SPRING_W * dt);
        x = target + (d0 + b * dt) * decay;
        velocity = (velocity - SPRING_W * b * dt) * decay;
        render();
        if (Math.abs(x - target) < 0.1 && Math.abs(velocity) < 0.1) {
          x = target;
          render();
          stopAnim();
          return;
        }
        raf = requestAnimationFrame(step);
      });
    }

    function pushSample(time, clientX) {
      samples.push({ t: time, x: clientX });
      while (samples.length > 2 && time - samples[0].t > VEL_WINDOW) samples.shift();
    }

    track.addEventListener('pointerdown', function (event) {
      if (!looping || !setW) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      stopAnim();
      dragging = true;
      moved = false;
      pointerStartX = event.clientX;
      pointerStartPos = x;
      samples = [];
      pushSample(event.timeStamp, event.clientX);
      track.classList.add('is-dragging');
      inner.style.willChange = 'transform';
    }, listen);

    window.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - pointerStartX;
      if (Math.abs(dx) > 4) moved = true;
      x = pointerStartPos - dx;
      pushSample(event.timeStamp, event.clientX);
      render();
    }, listen);

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      pushSample(event.timeStamp, event.clientX);
      var first = samples[0];
      var last = samples[samples.length - 1];
      var span = last.t - first.t;
      var v = span > 0 ? -(last.x - first.x) / span : 0;
      if (Math.abs(v) < MIN_FLING) v = 0;
      var maxThrow = MAX_THROW_CARDS * pitch;
      var throwDist = Math.max(-maxThrow, Math.min(maxThrow, v * THROW_HORIZON));
      settle(Math.round((x + throwDist) / pitch) * pitch, v * 1000);
    }

    window.addEventListener('pointerup', endDrag, listen);
    window.addEventListener('pointercancel', endDrag, listen);

    track.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, { capture: true, signal: controller.signal });

    track.addEventListener('dragstart', function (event) { event.preventDefault(); }, listen);

    track.addEventListener('focusin', function (event) {
      if (!looping || !setW) return;
      var card = event.target.closest(CARD_SELECTOR);
      if (!card) return;
      var cardRect = card.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var delta = 0;
      if (cardRect.left < trackRect.left) delta = cardRect.left - trackRect.left;
      else if (cardRect.right > trackRect.right) delta = cardRect.right - trackRect.right;
      if (!delta) return;
      stopAnim();
      x += delta;
      render();
    }, listen);

    desktop.addEventListener('change', apply, listen);
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    }, listen);

    section._odditTeardown = function () {
      controller.abort();
      stopAnim();
      clearTimeout(resizeTimer);
      dropClones();
      setWrapped(true);
      allCards.forEach(function (card) { inner.appendChild(card); });
      if (track._odditDragCtrl === controller) delete track._odditDragCtrl;
      delete section._odditTeardown;
    };

    apply();
    requestAnimationFrame(function () { if (looping) build(); });
  }

  function decodeText(value) {
    var field = document.createElement('textarea');
    field.innerHTML = value || '';
    return field.value.replace(/\s+/g, ' ').trim();
  }

  function fetchYotpoReviews(appKey, path, perPage) {
    var url = YOTPO_API + encodeURIComponent(appKey) + path + '?per_page=' + perPage + '&page=1';
    if (!yotpoRequests[url]) {
      yotpoRequests[url] = fetch(url, { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('Yotpo request failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var response = (data && data.response) || {};
          var products = response.products || [];
          var byId = {};
          products.forEach(function (product) { byId[product.id] = product; });
          return (response.reviews || []).map(function (review) {
            var product = byId[review.product_id] || products[0] || {};
            return {
              id: review.id,
              score: review.score,
              createdAt: Date.parse(review.created_at) || 0,
              title: decodeText(review.title),
              content: decodeText(review.content),
              author: decodeText(review.user && review.user.display_name),
              productKey: product.domain_key ? String(product.domain_key) : '',
              productName: decodeText(product.name),
              productImage: product.image_url || '',
              productLink: product.product_link || ''
            };
          });
        })
        .catch(function (error) {
          delete yotpoRequests[url];
          throw error;
        });
    }
    return yotpoRequests[url];
  }

  function loadYotpoReviews(config) {
    var tags = (config.tags || []).map(function (tag) {
      var urls = {};
      var keys = (tag.products || []).map(function (entry) {
        var key = String(entry[0]);
        urls[key] = entry[1];
        return key;
      });
      return { filter: tag.filter, urls: urls, featured: keys.slice(0, config.productsPerTag || 0) };
    });

    var featured = [];
    tags.forEach(function (tag) {
      tag.featured.forEach(function (key) {
        if (featured.indexOf(key) === -1) featured.push(key);
      });
    });

    var requests = [fetchYotpoReviews(config.appKey, '/reviews.json', YOTPO_POOL_SIZE)].concat(
      featured.map(function (key) {
        return fetchYotpoReviews(config.appKey, '/products/' + encodeURIComponent(key) + '/reviews.json', YOTPO_PRODUCT_SIZE);
      })
    );

    return Promise.allSettled(requests).then(function (results) {
      var seen = {};
      var reviews = [];
      var loaded = false;
      results.forEach(function (result) {
        if (result.status !== 'fulfilled') return;
        loaded = true;
        result.value.forEach(function (review) {
          if (seen[review.id]) return;
          seen[review.id] = true;
          if (review.score >= (config.minScore || 1) && review.content) reviews.push(review);
        });
      });
      if (!loaded) throw new Error('Yotpo reviews unavailable');

      reviews.sort(function (a, b) { return b.createdAt - a.createdAt; });

      var perTag = config.perTag || 4;
      if (!tags.length) {
        return reviews.slice(0, perTag).map(function (review) {
          return { review: review, filter: '', url: review.productLink };
        });
      }

      var used = {};
      var picks = [];
      tags.forEach(function (tag) {
        var count = 0;
        var shown = {};
        [true, false].forEach(function (distinct) {
          reviews.forEach(function (review) {
            if (count >= perTag || used[review.id] || !tag.urls[review.productKey]) return;
            if (distinct && shown[review.productKey]) return;
            shown[review.productKey] = true;
            used[review.id] = true;
            count++;
            picks.push({ review: review, filter: tag.filter, url: tag.urls[review.productKey] });
          });
        });
      });
      return picks;
    });
  }

  function buildReviewCard(template, pick) {
    var review = pick.review;
    var card = template.content.firstElementChild.cloneNode(true);
    card.setAttribute('data-oddit-category', pick.filter);

    var title = card.querySelector('.oddit-section-testimonials__review-title');
    if (review.title) title.textContent = review.title; else title.remove();
    card.querySelector('.oddit-section-testimonials__review-body').textContent = review.content;
    var author = card.querySelector('.oddit-section-testimonials__reviewer-handle');
    if (review.author) author.textContent = review.author; else author.remove();

    var bar = card.querySelector('.oddit-section-testimonials__product-link');
    if (!pick.url || !review.productName) {
      bar.remove();
      return card;
    }
    var link = bar.querySelector('a');
    link.href = pick.url;
    link.setAttribute('aria-label', review.productName);
    link.querySelector('.oddit-section-testimonials__product-name').textContent = review.productName;
    var image = link.querySelector('img');
    if (review.productImage) image.src = review.productImage; else image.remove();
    return card;
  }

  function whenNear(section, callback) {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      callback();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      callback();
    }, { rootMargin: '800px 0px' });
    observer.observe(section);
  }

  function prepareSection(section) {
    if (section._odditTeardown || section._odditReviewsPending) return;

    var configNode = section.querySelector('[data-oddit-reviews-config]');
    if (!configNode) {
      initSection(section);
      return;
    }

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      config = null;
    }

    var inner = section.querySelector('.oddit-section-testimonials__track-inner');
    var cardTemplate = section.querySelector('template[data-oddit-reviews-card]');
    var fallbackTemplate = section.querySelector('template[data-oddit-reviews-fallback]');
    section._odditReviewsPending = true;

    function finish(cards) {
      section._odditReviewsPending = false;
      if (!section.isConnected) return;
      inner.textContent = '';
      cards.forEach(function (card) { inner.appendChild(card); });

      var present = {};
      cards.forEach(function (card) { present[card.getAttribute('data-oddit-category')] = true; });
      section.querySelectorAll(TAG_SELECTOR).forEach(function (tag) {
        var value = tag.getAttribute('data-oddit-filter');
        if (value !== 'all' && !present[value]) tag.remove();
      });

      section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      initSection(section);
    }

    function fallback() {
      var cards = fallbackTemplate
        ? Array.prototype.slice.call(fallbackTemplate.content.cloneNode(true).querySelectorAll(CARD_SELECTOR))
        : [];
      finish(cards);
    }

    if (!config || !config.appKey || !inner || !cardTemplate) {
      fallback();
      return;
    }

    whenNear(section, function () {
      loadYotpoReviews(config)
        .then(function (picks) {
          if (!picks.length) {
            fallback();
            return;
          }
          finish(picks.map(function (pick) { return buildReviewCard(cardTemplate, pick); }));
        })
        .catch(fallback);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(prepareSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section && section._odditTeardown) section._odditTeardown();
  });
})();
